import Octagon from './Octagon'
export default Octagon